<template>
  <div>
    <mu-stepper :activeStep="activeStep">
      <mu-step>
        <mu-step-label>
          {{$t('message.gettingStartedTabYou')}}
        </mu-step-label>
      </mu-step>
      <mu-step>
        <mu-step-label>
          {{$t('message.gettingStartedTabHealth')}}
        </mu-step-label>
      </mu-step>
      <mu-step>
        <mu-step-label>
          {{$t('message.gettingStartedTabLocation')}}
        </mu-step-label>
      </mu-step>
      <mu-step>
        <mu-step-label>
          {{$t('message.gettingStartedTabGoals')}}
        </mu-step-label>
      </mu-step>
      <mu-step>
        <mu-step-label>
          {{$t('message.gettingStartedTabPersonalise')}}
        </mu-step-label>
      </mu-step>
    </mu-stepper>
    <mu-card align="left">
      <div v-if="isLoading">
        <mu-card-text align="center">
          <img src="static/Dashboard.gif" width="25%"/>
          <br/>
          {{$t('message.loadingText')}}
        </mu-card-text>
      </div>
      <div v-if="!isLoading && $store.state.list.diabetes_types">
        <mu-card-header
          :title="title"
          :subTitle="subTitle"
        ></mu-card-header>
        <mu-card-text>

          <div class="mu-text-field-label">
            Date of birth
          </div>
          <mu-row v-if="dobItems" style="margin-bottom: 24px;">

            <mu-col desktop="33" tablet="33" width="33">
              <select
                name="birth_day"
                v-validate
                :class="{'error': errors.first('birth_day')}"
                :data-vv-rules="'required'"
                data-vv-name="birth_day"
                data-vv-as="day"
                v-model="dob.day" class="native-select"
              >
                <option :value="null">Day</option>
                <option
                  v-for="(day, index) in dobItems.days"
                  :key="'day-' + index"
                  :value="day"
                >{{day}}
                </option>
              </select>
            </mu-col>
            <mu-col desktop="33" tablet="33" width="33">
              <select
                name="birth_month"
                v-validate
                :class="{'error': errors.first('birth_month')}"
                :data-vv-rules="'required'"
                data-vv-name="birth_month"
                data-vv-as="month"
                v-model="dob.month" class="native-select">
                <option :value="null">Month</option>
                <option
                  v-for="(month, index) in dobItems.months"
                  v-once
                  :key="'month-' + index"
                  :value="month.value"
                >{{localizeMonth(month.name)}}
                </option>
              </select>
            </mu-col>
            <mu-col desktop="33" tablet="33" width="33">
              <select
                name="birth_year"
                v-validate
                :class="{'error': errors.first('birth_year')}"
                :data-vv-rules="'required'"
                data-vv-name="birth_year"
                data-vv-as="year"
                v-model="dob.year"
                class="native-select">
                <option :value="null">Year</option>
                <option
                  v-for="(year, index) in dobItems.years"
                  v-once
                  :key="'year-' + index"
                  :value="year.value"
                >{{year.value}}
                </option>
              </select>
            </mu-col>
          </mu-row>
          <mu-row>
            <mu-col desktop="50" tablet="50">
              <mu-select-field
                id="diabetesTxt"
                v-validate
                :data-vv-rules="'required'"
                data-vv-name="diabetes_type"
                data-vv-value-path="inputValue"
                data-vv-as="diabetes type"
                :errorText="errors.first('diabetes_type')"
                :underlineShow="underlineShow"
                :fullWidth="fullWidth"
                :maxHeight="300"
                hintText="Select"
                v-model="model.diabetes_type_id"
                :label="$t('message.accountPreferencesWhatBringsYouHere')"
              >
                <mu-menu-item
                  v-for="(item, index) in lists.diabetes_types"
                  v-if="item.hide === 0"
                  :key="'diabetes-type-' + index"
                  :value="item.diabetes_type_id"
                  :title="localizeRegistrationReason(item.diabetes_type)"
                ></mu-menu-item>
              </mu-select-field>
              <mu-select-field
                id="sexTxt"
                v-validate
                :data-vv-rules="'required'"
                data-vv-name="sex"
                data-vv-value-path="inputValue"
                :data-vv-as="$t('message.accountPreferencesSex')"
                :errorText="errors.first('sex')"
                :underlineShow="underlineShow"
                :fullWidth="fullWidth"
                :maxHeight="300"
                :hintText="$t('message.selectText')"
                v-model="model.gender_id"
                :label="$t('message.accountPreferencesSex')">
                <mu-menu-item
                  v-for="item, index in $store.state.list.genders"
                  :key="'gender-' + index"
                  :value="item.gender_id"
                  :title="localizeSex(item.gender)"
                ></mu-menu-item>
              </mu-select-field>

              <div v-bind:class="{bottomSpacingOther: !model.behalf_of_other}">
                <mu-checkbox
                  id="behalfOfOtherCheckBox"
                  @click.native="forceUpdate"
                  v-model="model.behalf_of_other"
                  :label="$t('message.labelBehalfSomeoneElse')"
                />
              </div>

              <div v-if="model.behalf_of_other">
                <mu-select-field
                  id="relationshipTxt"
                  v-validate
                  :data-vv-rules="'required'"
                  data-vv-name="relationship"
                  data-vv-value-path="inputValue"
                  data-vv-as="relationship"
                  :errorText="errors.first('relationship')"
                  :underlineShow="underlineShow"
                  :fullWidth="fullWidth"
                  :maxHeight="300"
                  :hintText="'Please select'"
                  v-model="model.relationship_id"
                  :label="$t('message.labelRelationship')">
                  <mu-menu-item
                    v-for="(item, index) in lists.relationships"
                    :key="'relationship-' + index"
                    :value="item.relationship_id"
                    :title="localizeRelationship(item.title)"
                  >
                  </mu-menu-item>
                </mu-select-field>
                <mu-text-field
                  id="relationshipNameTxt"
                  :label="$t('message.nameText')"
                  v-model="model.behalf_of_name"
                  :fullWidth="true"
                  :hintText="$t('message.placeholderText')"
                  :rows="3"
                  :rowsMax="6"
                  icon="person"
                  type="text"
                />
              </div>
            </mu-col>
            <mu-col desktop="50" tablet="50" align="center" class="isDesktop">
              <img width="80%" src="static/step-1-about.svg"/>
            </mu-col>
          </mu-row>
          <mu-raised-button
            id="submitBtn"
            :fullWidth="true"
            secondary
            :disabled="isSaving"
            @click.native="submitForm"
            :label="isSaving ? $t('message.savingText'): $t('message.nextText')"></mu-raised-button>
        </mu-card-text>
      </div>
    </mu-card>
  </div>
</template>
<script>

  import AccountApi from '../../api/Account'
  import UserApi from '../../api/User'
  import {Objects} from '../../helpers/Utilities'
  import RelationshipLocalizerMixin from '../../mixins/Localization/Relationships'
  import MonthLocalizerMixin from '../../mixins/Localization/DateMonths'
  import SexLocalizerMixin from '../../mixins/Localization/Genders'
  import RegisterReasonLocalizerMixin from '../../mixins/Localization/RegisterReasons'
  import AnalyticsTrackingMixin from '../../mixins/AnalyticsTrackingMixin';
  import AuthenticationManager from "../../helpers/AuthenticationManager";
  import _ from "lodash";
  import {sha256} from "js-sha256";
  import axios from "axios";
  import PaymentApi from "../../api/Payment";


  const DobObject = Objects.DobObject;

  export default {
    mixins: [RelationshipLocalizerMixin, MonthLocalizerMixin, SexLocalizerMixin, RegisterReasonLocalizerMixin, AnalyticsTrackingMixin],
    name: 'about-yourself',
    data() {
      return {
        title: this.$t('message.gettingStartedAboutTitle'),
        subTitle: this.$t('message.gettingStartedAboutSubTitle'),
        activeDiabetesType: {},
        isLoading: true,
        isSaving: false,
        isDiabetic: true,
        activeStep: 0,
        fullWidth: true,
        underlineShow: true,
        model: {
          diabetes_type_id: null,
        },
        lists: {},
        dobItems: DobObject,
        dob: {
          day: null,
          month: null,
          year: null
        },
        paidAmount: 0,
      }
    },
    watch: {
      'model.diabetes_type_id': function (newValue, oldValue) {
        let self = this;
        let types = JSON.parse(JSON.stringify(self.lists.diabetes_types))
        if (newValue != null) {
          self.activeDiabetesType = types.filter(function (type) {
            return type.diabetes_type_id === newValue
          })[0];
          if (_.has(self.activeDiabetesType, 'is_diabetic')) {
            if (self.activeDiabetesType.is_diabetic === true) {
              self.isDiabetic = true
            }
            else {
              self.isDiabetic = false
            }
          }
        }
      },
      'dob.day': function () {
        let self = this;
        self.formatDateOfBirth()
      },
      'dob.month': function () {
        let self = this;
        self.formatDateOfBirth()
      },
      'dob.year': function () {
        let self = this;
        self.formatDateOfBirth()
      }
    },
    computed: {
      isValidAge: function () {
        if (this.dob.day && this.dob.month && this.dob.year) {
          let userDob = `${this.dob.year}-${this.dob.month}-${this.dob.day}`;
          let dob = moment(userDob);
          let ageRestrict = moment().subtract(18, 'years');
          let validAge = moment(dob).isBefore(ageRestrict);
          return validAge;
        }
      },
      isOlderThan100: function() {
        if (this.dob.day && this.dob.month && this.dob.year) {
          let userDob = `${this.dob.year}-${this.dob.month}-${this.dob.day}`;
          let dob = moment(userDob);
          let ageRestrict = moment().subtract(100, 'years');
          let validAge = moment(dob).isBefore(ageRestrict);
          return validAge;
        }
      }
    },
    mounted() {
      let self = this;
      self.$gtag.pageview('/getting-started/about-you');
      self.lists = self.$store.state.list;
      AccountApi.getAccount()
        .then(function (response) {
          self.model = response.data;
          self.lists = self.$store.state.list;
          if (self.model.diabetes_type_id === 0) {
            self.model.diabetes_type_id = null
          }
          if (self.model.gender_id === 0) {
            self.model.gender_id = null
          }
          if (self.model.dob !== null) {
            const dob = self.model.dob.split('-');
            self.dob.year = dob[0];
            self.dob.month = dob[1];
            self.dob.day = dob[2];
            self.$forceUpdate();
          }
          if (self.model.on_behalf) {
          }
          else {
            self.model.on_behalf = false
          }
          self.$nextTick(function () {
            self.errors.clear();
            setTimeout(function () {
            }.bind(self), 500);
            self.isLoading = false
            self.trackPagePinterest();
            self.trackPageReddit();
          })
        });
    },
    methods: {
      submitForm() {
        let self = this;
        if (self.isOlderThan100 === true) {
          self.$toastr.error("You have to be under 100 to sign up");
          return;
        }

        self.$validator.validateAll()
          .then(function (valid) {
            if (valid && self.isValidAge) {
              self.isSaving = true;
              AccountApi.putAccount(self.model)
                .then(function (response) {
                  UserApi.onBoardingStatus()
                    .then(function (response) {
                      self.$store.commit('setOnBoardingStatus', response.data);
                      let timeout = setTimeout(function () {
                        self.$gtag.event('AboutPanelComplete',{
                          'event_category': 'Onboarding',
                          'event_label': 'Completed about you panel',
                          'value': 1
                        });
                        self.$router.push({
                          name: 'GettingStartedYourHealth'
                        });
                        clearTimeout(timeout)
                      }, 300)
                    })
                });
            } else if (!self.isValidAge) {
              self.$toastr.error("You have to be 18 or over to sign up");
            }
          })
          .catch(function (error) {
          })
      },
      formatDateOfBirth() {
        let self = this;
        if ((!_.isNull(self.dob.day)) && (!_.isNull(self.dob.month)) && (!_.isNull(self.dob.year))) {
          self.model.dob = self.dob.year + '-' + self.dob.month + '-' + self.dob.day
        }
      },
      forceUpdate() {
        let self = this;
        self.$forceUpdate()
      }
    }
  }
</script>
<style>
  .mu-text-field-help {
    position: static !important;
  }

  .bottomSpacingOther {
    padding-bottom: 14px;
  }

  .mu-menu-list.mu-menu-destop {
    min-width: 130px !important;
  }

  .mu-menu {
    min-width: 130px !important
  }

</style>



// WEBPACK FOOTER //
// AboutYourself.vue?c128e430